module.exports = __webpack_public_path__ + "static/map_usa-43d9d3a466dcd0496a189e76c6ffbb4f.png";